// extracted by mini-css-extract-plugin
export var boxItems = "_7z-1";
export var button = "_7z-5";
export var filterGroupBox = "_7z-0";
export var icon = "_7z-2";
export var iconSecondary = "_7z-4";
export var iconWrapper = "_7z-3";